import { render, staticRenderFns } from "./GoodsSummary.vue?vue&type=template&id=2ccabc1c&scoped=true&"
import script from "./GoodsSummary.vue?vue&type=script&lang=js&"
export * from "./GoodsSummary.vue?vue&type=script&lang=js&"
import style1 from "./GoodsSummary.vue?vue&type=style&index=1&id=2ccabc1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccabc1c",
  null
  
)

export default component.exports